module.exports = __webpack_public_path__ + "img/lock.ad5c8687.svg";